var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Content",
    {
      class: { "icon-loading": _vm.initialLoading },
      attrs: { "app-name": "health" }
    },
    [
      _c("PersonsNavigation"),
      _vm._v(" "),
      _c(
        "AppContent",
        [
          _c("div", { staticClass: "top-bar" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-menu-topright" },
            [
              _c(
                "Actions",
                { attrs: { title: "Details" } },
                [
                  _c("ActionButton", {
                    attrs: { icon: "icon-menu-sidebar" },
                    on: {
                      click: function($event) {
                        return _vm.$store.commit(
                          "showSidebar",
                          !_vm.showSidebar
                        )
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.person && _vm.person.name
            ? _c("h3", { staticClass: "icon-user h3-icon" }, [
                _vm._v("\n\t\t\t" + _vm._s(_vm.person.name) + "\n\t\t")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.person && _vm.activeModule === "person"
            ? _c("PersonsContent")
            : _vm._e(),
          _vm._v(" "),
          _vm.person &&
          _vm.activeModule === "weight" &&
          _vm.person.enabledModuleWeight
            ? _c("WeightContent")
            : _vm._e(),
          _vm._v(" "),
          _vm.person &&
          _vm.activeModule === "feeling" &&
          _vm.person.enabledModuleFeeling
            ? _c("FeelingContent")
            : _vm._e(),
          _vm._v(" "),
          _vm.person &&
          _vm.activeModule === "measurement" &&
          _vm.person.enabledModuleMeasurement
            ? _c("MeasurementContent")
            : _vm._e(),
          _vm._v(" "),
          _vm.person &&
          _vm.activeModule === "sleep" &&
          _vm.person.enabledModuleSleep
            ? _c("SleepContent")
            : _vm._e(),
          _vm._v(" "),
          _vm.person &&
          _vm.activeModule === "smoking" &&
          _vm.person.enabledModuleSmoking
            ? _c("SmokingContent")
            : _vm._e(),
          _vm._v(" "),
          _vm.person &&
          _vm.activeModule === "activities" &&
          _vm.person.enabledModuleActivities
            ? _c("ActivitiesContent")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.person && !_vm.loading
        ? _c(
            "AppSidebar",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSidebar,
                  expression: "showSidebar"
                }
              ],
              attrs: {
                title: _vm.person.name,
                subtitle: _vm.t("health", "created at {creationTime}", {
                  creationTime: _vm.formatMyDate(_vm.person.insertTime)
                })
              },
              on: {
                close: function($event) {
                  return _vm.$store.commit("showSidebar", false)
                }
              }
            },
            [
              _c(
                "AppSidebarTab",
                {
                  attrs: {
                    id: "person",
                    name: "Person",
                    icon: "icon-user",
                    order: 0
                  }
                },
                [_c("PersonsSidebar")],
                1
              ),
              _vm._v(" "),
              _vm.person.enabledModuleWeight
                ? _c(
                    "AppSidebarTab",
                    {
                      attrs: {
                        id: "weight",
                        name: _vm.t("health", "Weight", {}),
                        icon: "icon-quota",
                        order: 1
                      }
                    },
                    [_c("WeightSidebar")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.person.enabledModuleFeeling
                ? _c(
                    "AppSidebarTab",
                    {
                      attrs: {
                        id: "feeling",
                        name: _vm.t("health", "Feeling"),
                        icon: "icon-category-monitoring",
                        order: 2
                      }
                    },
                    [_c("FeelingSidebar")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.person.enabledModuleMeasurement
                ? _c(
                    "AppSidebarTab",
                    {
                      attrs: {
                        id: "measurement",
                        name: _vm.t("health", "Measurementdata"),
                        icon: "icon-home",
                        order: 3
                      }
                    },
                    [_c("MeasurementSidebar")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.person.enabledModuleSleep
                ? _c(
                    "AppSidebarTab",
                    {
                      attrs: {
                        id: "sleep",
                        name: _vm.t("health", "Sleep"),
                        icon: "icon-download",
                        order: 4
                      }
                    },
                    [_c("SleepSidebar")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.person.enabledModuleSmoking
                ? _c(
                    "AppSidebarTab",
                    {
                      attrs: {
                        id: "smoking",
                        name: _vm.t("health", "Smoking"),
                        icon: "icon-address",
                        order: 5
                      }
                    },
                    [_c("SmokingSidebar")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.person.enabledModuleActivities
                ? _c(
                    "AppSidebarTab",
                    {
                      attrs: {
                        id: "activities",
                        name: _vm.t("health", "Activities"),
                        icon: "icon-upload",
                        order: 6
                      }
                    },
                    [_c("ActivitiesSidebar")],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }